const SemVerGte = require('semver/functions/gte')
const recordingFileToDate = require('cloud-utils/recording-file-to-date')
const { getBrowserInfo } = require('cloud-utils/helpers/browser-info-helpers')
const { MQTT_ONLY_DEVICE_SETTINGS } = require('./constants')
window.languagesList = [
  {
    lang_code: 'EN',
    name: 'English',
    language_key: 'en',
    flag: 'flag-icon-us'
  },
  {
    lang_code: 'ES',
    name: 'Spanish',
    language_key: 'es',
    flag: 'flag-icon-es'
  },
  {
    lang_code: 'FR',
    name: 'French',
    language_key: 'fr',
    flag: 'flag-icon-fr'
  },
  {
    lang_code: 'IT',
    name: 'Italian',
    language_key: 'it',
    flag: 'flag-icon-it'
  },
  {
    lang_code: 'PT',
    name: 'Portuguese',
    language_key: 'pt',
    flag: 'flag-icon-pt'
  },
  {
    lang_code: 'DE',
    name: 'German',
    language_key: 'de',
    flag: 'flag-icon-de'
  }
]
window.reportsList = [
  {
    id: 1,
    name: 'summaryReport',
    title: 'Summary Report',
    icon: 'timeline'
  },
  {
    id: 2,
    name: 'aggressiveDriving',
    title: 'Aggressive Driving',
    icon: 'timeline'
  },
  {
    id: 3,
    name: 'speedingReport',
    title: 'Speeding Report',
    icon: 'timeline'
  },
  {
    id: 4,
    name: 'geofenceReport',
    title: 'Geofence Report',
    icon: 'timeline'
  },
  {
    id: 5,
    name: 'dangerousDrivingReport',
    title: 'Dangerous Driving Report',
    icon: 'timeline'
  }
]
window.healthReportsList = [
  {
    id: 1,
    name: 'healthReport',
    title: 'Alarm Report',
    icon: 'verified_user'
  },
  {
    id: 2,
    name: 'alarmsReport',
    title: 'Alarms Report',
    icon: 'error'
  },
  {
    id: 3,
    name: 'dataUsageReport',
    title: 'Data Usage Report',
    icon: 'data_usage'
  }
]
window.deviceReportPaginationLimit = 200
window.groupSummaryReportPaginationLimit = 20
window.deviceEventsPaginationLimit = 20
window.makeId = function (len = 5) {
  var text = ''
  var possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (var i = 0; i < len; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}
window.fireRefreshEventOnWindow = function () {
  var evt = document.createEvent('HTMLEvents')
  evt.initEvent('resize', true, false)
  window.dispatchEvent(evt)
}
window.recordingFileToDate = recordingFileToDate
window.getBrowserInfo = getBrowserInfo
window.getTripDurationText = function (secs) {
  if (parseInt(secs) < 60) {
    secs = 60
  }
  var secNum = parseInt(secs, 10)
  var hours = Math.floor(secNum / 3600) % 24
  var minutes = Math.floor(secNum / 60) % 60
  var column = ''
  var hhMM = [hours, minutes].map(v => (v < 10 ? '0' + v : v))
  var returnValue = ''
  hhMM.forEach(function (data, index) {
    if (index === 0) {
      column = ':'
    } else {
      column = ''
    }
    returnValue += data + '' + column + ''
  })
  return returnValue
}
window.getCameraNameByStreamId = (translateService, edge, streamId) => {
  if ([window.frontCameraId, window.rearCameraId].includes(streamId)) {
    return translateService(
      streamId === window.frontCameraId ? 'frontCamera' : 'rearCamera'
    )
  } else {
    const auxiliaryCamera = edge.cameras.find(
      ({ cameraId }) => cameraId === streamId
    )
    const auxiliaryCameraIndex = edge.cameras.findIndex(
      ({ cameraId }) => cameraId === streamId
    )
    if (auxiliaryCamera && auxiliaryCamera.name) {
      return auxiliaryCamera.name
    } else {
      const auxiliaryCameraTitle = translateService('auxiliaryCamera')
      return (
        auxiliaryCameraTitle +
        ' ' +
        (auxiliaryCameraIndex !== -1
          ? streamId > 50
            ? streamId - 50
            : streamId
          : '...')
      )
    }
  }
}
window.getAngleBetween = (A, B) => {
  let angle = null
  const latA = A.lat
  const lonA = A.lon
  const latB = B.lat
  const lonB = B.lon

  // (when longitude or latitude is equal)
  if (lonA === lonB && latA > latB) {
    angle = Math.PI
  } else if (lonA === lonB && latA < latB) {
    angle = 0
  } else if (lonA > lonB && latA === latB) {
    angle = -(Math.PI / 2)
  } else if (lonA < lonB && latA === latB) {
    angle = Math.PI / 2
  }

  // (Longitude and latitude are not equal)
  else {
    const x1 = A.lat * Math.pow(10, 12)
    const x2 = B.lat * Math.pow(10, 12)
    const y1 = A.lon * Math.pow(10, 12)
    const y2 = B.lon * Math.pow(10, 12)
    angle = Math.atan2(y2 - y1, x2 - x1)
  }
  return (angle * 180) / Math.PI
}
window.isAI12Device = serialNumber => /^\d+$/.test(serialNumber)
window.isAI14Device = serialNumber => /^8\d+$/.test(serialNumber)
window.sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
;(function (apiKey) {
  if (apiKey) {
    ;(window.heap = window.heap || []),
      (heap.load = function (e, t) {
        ;(window.heap.appid = e), (window.heap.config = t = t || {})
        var r = t.forceSSL || 'https:' === document.location.protocol,
          a = document.createElement('script')
        ;(a.type = 'text/javascript'),
          (a.async = !0),
          (a.src =
            (r ? 'https:' : 'http:') +
            '//cdn.heapanalytics.com/js/heap-' +
            e +
            '.js')
        var n = document.getElementsByTagName('script')[0]
        n.parentNode.insertBefore(a, n)
        for (
          var o = function (e) {
              return function () {
                heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
              }
            },
            p = [
              'addEventProperties',
              'addUserProperties',
              'clearEventProperties',
              'identify',
              'resetIdentity',
              'removeEventProperty',
              'setEventProperties',
              'track',
              'unsetEventProperty'
            ],
            c = 0;
          c < p.length;
          c++
        )
          heap[p[c]] = o(p[c])
      })
    heap.load(apiKey)
  }
})(HEAP_API_KEY)
window.frontCameraId = 1
window.rearCameraId = 2
window.CAN_PLAY_RECORDING_STREAM_VERSION = '3.5.23'
window.CAN_EDIT_UI_CONFIG = '3.7.0'
window.CAN_EDIT_UI_CONFIG_IDLE_TO_STANDBY = '3.8.0'
window.CAN_PLAY_SELECTED_QUALITY_RECORDING_STREAM_VERSION = '3.8.0'
const timezoneToOffset = timezone => {
  const [h, m] = timezone.split(':').map(t => parseInt(t))
  return h * 60 + (h < 0 ? -m : m)
}
const timezonetoText = timezone => {
  const [h, m] = timezone.split(':').map(t => parseInt(t))
  return `GMT ${h < 0 ? '-' : '+'} ${Math.abs(h)}${m === 0 ? '' : `:${m}`}`
}
window.TimezonesList = [
  '-12:00',
  '-11:00',
  '-10:00',
  '-09:30',
  '-09:00',
  '-08:00',
  '-07:00',
  '-06:00',
  '-05:00',
  '-04:00',
  '-03:30',
  '-03:00',
  '-02:00',
  '-01:00',
  '+00:00',
  '+01:00',
  '+02:00',
  '+03:00',
  '+03:30',
  '+04:00',
  '+04:30',
  '+05:00',
  '+05:30',
  '+05:45',
  '+06:00',
  '+06:30',
  '+07:00',
  '+08:00',
  '+08:45',
  '+09:00',
  '+09:30',
  '+10:00',
  '+10:30',
  '+11:00',
  '+12:00',
  '+12:45',
  '+13:00',
  '+14:00'
].map(timezone => ({
  raw: timezone,
  offset: timezoneToOffset(timezone),
  text: timezonetoText(timezone)
}))
const LOW_QUALITY_RECORDING_STREAM = {
  id: 1,
  value: 'lq',
  shortName: 'NQ',
  description:
    'Provides faster streaming and reduced data usage at lower frame rates',
  translateName: 'normalQuality',
  playbackRate: 3
}
const HIGH_QUALITY_RECORDING_STREAM = {
  id: 2,
  value: 'hq',
  shortName: 'HQ',
  description:
    'Provides slower streaming and high data usage at recorded frame rates',
  translateName: 'highQuality',
  playbackRate: 1
}
const URL_REGEX = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
window.validateUrl = url => {
  return URL_REGEX.test(url)
}
window.LOW_QUALITY_RECORDING_STREAM = LOW_QUALITY_RECORDING_STREAM
window.HIGH_QUALITY_RECORDING_STREAM = HIGH_QUALITY_RECORDING_STREAM
window.recordingStreamQualities = [
  LOW_QUALITY_RECORDING_STREAM,
  HIGH_QUALITY_RECORDING_STREAM
]
// window.MAX_SUPPORTED_DEVICE_VERSION = [
//   // 'api.stage2.surfsight.net',
//   'api-prod.surfsight.net',
//   'api.de.surfsight.net'
// ].some(domain => (V2_BASEURL || '').includes(domain))
//   ? '3.12.99'
//   : `${Number.MAX_SAFE_INTEGER}.${Number.MAX_SAFE_INTEGER}.${Number.MAX_SAFE_INTEGER}`
window.MAX_SUPPORTED_DEVICE_VERSION = `${Number.MAX_SAFE_INTEGER}.${Number.MAX_SAFE_INTEGER}.${Number.MAX_SAFE_INTEGER}`
window.HIDDEN_EVENTS = ['deviceActivation']
window.filterEnvironmentDeviceSettings = deviceEventSettings => {
  return deviceEventSettings.filter(
    ({ fromVersion, name }, index) =>
      (!fromVersion ||
        !window.MAX_SUPPORTED_DEVICE_VERSION ||
        SemVerGte(window.MAX_SUPPORTED_DEVICE_VERSION, fromVersion)) &&
      !window.HIDDEN_EVENTS.includes(name)
  )
}

window.getRange = function (start, end, step) {
  let range = []
  for (let i = start; i <= end; i += step) {
    range.push(i)
  }
  return range
}

window.messageFormatter = function (message, placeholders) {
  const charArr = message.split('')
  let newArr = []
  for (let i = 0; i < charArr.length; i++) {
    if (charArr[i - 1] === '{' && charArr[i + 1] === '}') {
      newArr.push(placeholders[charArr[i] - 1])
    } else if (charArr[i] !== '{' && charArr[i] !== '}') {
      newArr.push(charArr[i])
    }
  }
  return newArr.join('')
}

window.milesToKilometers = miles => {
  return miles * 1.609344
}

window.isMqttBasedDevice = serialNumber => /^8/.test(serialNumber)

window.sanitizeSettingsForDevice = (imei, deviceConfig) => {
  if (!window.isMqttBasedDevice(imei)) {
    // AI-12 = non-MQTT device
    const sanitized = { ...deviceConfig }

    for (const setting of MQTT_ONLY_DEVICE_SETTINGS) {
      if (sanitized.hasOwnProperty(setting)) {
        delete sanitized[setting]
      }
    }

    return sanitized
  }
  // MQTT devices → return untouched
  return deviceConfig
}
